{
  "version": 1,
  "asset_id": "9addc4fc-6659-4059-8f0d-944af578ede1",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/9addc4fc-6659-4059-8f0d-944af578ede1/destination-roofing-crew-citrus-county-fl-1024.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/9addc4fc-6659-4059-8f0d-944af578ede1/destination-roofing-crew-citrus-county-fl-1024.avif",
  "original_filename": "destination-roofing-crew-citrus-county-fl-1024.avif",
  "size": 43348,
  "content_type": "image/avif",
  "created_at": "2026-07-21T15:42:33Z"
}
